import React, { ReactNode, forwardRef, useMemo } from 'react';

import { cn } from '../../../lib/css/className/className';
import { getSizeSkin } from '../../../lib/skin/getSizeSkin/getSizeSkin';
import { TestProps } from '../../../internal/types/testTypes';

import './PageHeadWrapper.css';

const cls = cn('PageHeadWrapper');

export interface PageHeadWrapperProps extends TestProps {
    /** Внешний атрибут className */
    className?: string;

    /** Наличие горизонтального меню */
    children: ReactNode;

    'aria-hidden'?: boolean;

    /** Смещение сверху */
    topOffset?: number;
}

export const PageHeadWrapper = forwardRef<HTMLDivElement, PageHeadWrapperProps>(function PageHeadWrapper(
    { className, children, 'data-testid': dataTestId, 'aria-hidden': ariaHidden, topOffset = 0 },
    ref,
) {
    const skinSizeClass = getSizeSkin('layout');

    const offsetStyle = useMemo(
        () =>
            topOffset
                ? {
                      top: `${topOffset}px`,
                  }
                : undefined,
        [topOffset],
    );

    return (
        <div
            className={cls({}, [className, skinSizeClass])}
            ref={ref}
            data-testid={dataTestId}
            aria-hidden={ariaHidden ? 'true' : undefined}
            style={offsetStyle}
        >
            {children}
        </div>
    );
});
